import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { User, Lock, Bell, Globe } from 'lucide-react';
interface SettingsProps {
  onLogout: () => void;
}
export function Settings({
  onLogout
}: SettingsProps) {
  return <MainLayout title="Einstellungen" onLogout={onLogout} data-id="element-630">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-631">
        <Card title="Profil Einstellungen" data-id="element-632">
          <div className="flex items-start gap-6" data-id="element-633">
            <div className="h-20 w-20 rounded-full bg-teal-500 flex items-center justify-center text-2xl font-bold text-white" data-id="element-634">
              AD
            </div>
            <div className="flex-1 space-y-4" data-id="element-635">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-636">
                <Input label="Vorname" defaultValue="Admin" data-id="element-637" />
                <Input label="Nachname" defaultValue="User" data-id="element-638" />
                <Input label="E-Mail" defaultValue="admin@neocube.one" data-id="element-639" />
                <Input label="Rolle" defaultValue="Administrator" disabled data-id="element-640" />
              </div>
              <Button data-id="element-641">Speichern</Button>
            </div>
          </div>
        </Card>

        <Card title="Plattform Konfiguration" data-id="element-642">
          <div className="space-y-4" data-id="element-643">
            <div className="flex items-center justify-between py-3 border-b border-slate-100" data-id="element-644">
              <div className="flex items-center gap-3" data-id="element-645">
                <Bell className="h-5 w-5 text-slate-400" data-id="element-646" />
                <div data-id="element-647">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-648">
                    E-Mail Benachrichtigungen
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-649">
                    Bei kritischen Tickets und Updates
                  </p>
                </div>
              </div>
              <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in" data-id="element-650">
                <input type="checkbox" name="toggle" id="toggle" className="toggle-checkbox absolute block w-5 h-5 rounded-full bg-white border-4 appearance-none cursor-pointer checked:right-0 checked:border-teal-500" defaultChecked data-id="element-651" />
                <label htmlFor="toggle" className="toggle-label block overflow-hidden h-5 rounded-full bg-slate-300 cursor-pointer checked:bg-teal-500" data-id="element-652"></label>
              </div>
            </div>

            <div className="flex items-center justify-between py-3 border-b border-slate-100" data-id="element-653">
              <div className="flex items-center gap-3" data-id="element-654">
                <Lock className="h-5 w-5 text-slate-400" data-id="element-655" />
                <div data-id="element-656">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-657">
                    2-Faktor Authentifizierung
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-658">
                    Für alle Administratoren erzwingen
                  </p>
                </div>
              </div>
              <Button size="sm" variant="outline" data-id="element-659">
                Konfigurieren
              </Button>
            </div>

            <div className="flex items-center justify-between py-3" data-id="element-660">
              <div className="flex items-center gap-3" data-id="element-661">
                <Globe className="h-5 w-5 text-slate-400" data-id="element-662" />
                <div data-id="element-663">
                  <h4 className="text-sm font-medium text-slate-900" data-id="element-664">
                    Sprache
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-665">
                    Plattform Spracheinstellung
                  </p>
                </div>
              </div>
              <span className="text-sm font-medium text-slate-900" data-id="element-666">
                Deutsch (DE)
              </span>
            </div>
          </div>
        </Card>
      </div>
    </MainLayout>;
}